import { render, staticRenderFns } from "./UserViewModal.vue?vue&type=template&id=88b4355e&scoped=true"
import script from "./UserViewModal.vue?vue&type=script&lang=js"
export * from "./UserViewModal.vue?vue&type=script&lang=js"
import style0 from "./UserViewModal.vue?vue&type=style&index=0&id=88b4355e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b4355e",
  null
  
)

export default component.exports